/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { get, map, isEmpty, find } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../../components/layout/Layout"
import Table from "../../../components/form/TableDetail";
import Toolbar from "./Toolbar";
import Notification from "../../../components/form/Notification";
import Alert from "../../../components/form/Alert";
import { PageSize, countPage } from "../../../config/const"
import { Pagination, Stack, Chip, Link as LinkMui, } from '@mui/material';

import { getLog } from "../../../store/config/thunk/log/getAll";
import { getLogFilter } from "../../../store/config/thunk/log/getAllFilterLogs";

const Logs = () => {
  const [__] = useTranslation("log");
  const dispatch = useDispatch();
  const [filter, setFilter] = useState({});
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [showNoti, setShowNoti] = useState({ open: false, msg: "", variant: "error", action: "post" })
  const [alert, setAlert] = useState({ open: false, title: "", subtitle: "", type: "" })

  const log = useSelector(state => state.config.log);
 
  const logActions = __(`logActions`, { returnObjects: true });

  const getData = ({page}) => {
    dispatch(getLog({page}));
  }

  const reload = () => getData({page: 1});

  useEffect(() => {
    setAnchorEl(false)
    getData({page: 1});
  }, [])

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const closeAlert = () => {
    setAlert({ open: false, title: "", subtitle: "", type: "", btn: "" })
  }

  const setError = (err, action) => {
    if (!isEmpty(err) && !!get(err, "Message", "")) {
      setAlert({
        open: true,
        title: get(err, "Message", ""),
        subtitle: (<ul>{map(get(err, "ValidationError", []), (item) => <li>{`• ${item}`}</li>)}</ul>),
        type: "error",
        btn: __(`${module}.actions.close`),
        func: closeAlert
      })
    } else {
      setAlert({
        open: true,
        type: "default",
        btn: __(`${module}.actions.close`),
        func: closeAlert
    })
    }
    handleCloseMenu()
  }

  const headTable = [
    {
      key: "docId",
      label: __(`table.cols.docId`),
      align: "center"
    },
    {
      key: "maeId",
      label: __(`table.cols.maeId`),
      align: "center"
    },
    {
      key: "action",
      label: __(`table.cols.action`),
      align: "center"
    },
    {
      key: "Date",
      label: __(`table.cols.date`),
      align: "center"
    },
    {
      key: "screen",
      label: __(`table.cols.screen`),
      align: "center"
    },
    {
      key: "users",
      label: __(`table.cols.users`),
      align: "center"
    },
  ]

  const dataTable = map(get(log, "data.data", []), (row, i) => ({
    ...row,
    action: <Chip label={get(find(logActions, ({ value }) => value === get(row, "action", 1)), "label")} sx={{ bgcolor: `${get(find(logActions, ({ value }) => value === get(row, "action", 1)), "color")}26`, color: get(find(logActions, ({ value }) => value === get(row, "action", 1)), "color") }} />,
    Date: new Date(get(row, "date")).toISOString().replace('T', ' ').split('.')[0],
  }))

    const onChangePagination = (e, page) => getData({ page })

  return (
    <Layout
      propsToolbar={{
        title: __(`head.name`),
        code: null,
        btnLabel: null
      }}
    >
      <Toolbar setFilter={setFilter} __={__} getData={getData} reload={reload} isLoading={get(log, "isLoading", false)} />
      <Table headTable={headTable}
        dataTable={dataTable}
        __={__}
        sizeFilters={125}
        loading={get(log, "isLoading", false)}
      />
      <Stack sx={{ mt: 2 }} alignItems="flex-end">
        <Pagination
          count={countPage(get(log, "data.totalRecord", 1))}
          page={get(log, "data.currentPage", 1)}
          onChange={onChangePagination}
          color="secondary"
          sx={{ "& li > button": { borderRadius: 1 } }}
          disabled={get(log, "isLoading", false)}
        />
      </Stack>
      <Notification __={__} showNoti={showNoti} setShowNoti={setShowNoti} />
      <Alert
        title={get(alert, "title")}
        subtitle={get(alert, "subtitle")}
        btn1={{ func: get(alert, "func") }}
        btn2={{}}
        type={get(alert, "type")}
        openAlert={get(alert, "open")}
        closeAlert={closeAlert}
      />
    </Layout>
  )
}

export default Logs;